import React__default from 'react';
import { DepartmentIcon } from '@deal/components';
import MessageBubble from '../../MessageBubble/index.js';
import MessageBubbleText from '../../MessageBubbleText/index.js';
import { ConsumerRichCardEvents } from '../../../containers/RichCardEventEmitter/ConsumerEventData/index.js';
import { useRichCardEventEmitter } from '../../../containers/RichCardEventEmitter/index.js';
import { guestChatCreateRequestRichCard } from '../../../services/richCardFactory.js';
import HeroWithImage from '../components/HeroWithImage/index.js';
import CallToAction from '../components/CallToAction/index.js';
import { GuestChatCategoryComponent } from './GuestChatCategory.generated.js';
import styles from './styles.css.js';

var GuestChatCreateRequestMessage = function GuestChatCreateRequestMessage(_a) {
  var message = _a.message,
      myself = _a.myself;
  var richCardEventEmitter = useRichCardEventEmitter();

  var _b = guestChatCreateRequestRichCard(message),
      expertId = _b.expertId,
      categoryId = _b.categoryId;

  return React__default.createElement(GuestChatCategoryComponent, {
    variables: {
      categoryId: categoryId
    }
  }, function (_a) {
    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.category && data.category.ancestorWithPath) {
      var category_1 = data.category.ancestorWithPath;
      var banner = category_1 && category_1.contentAssets.bannerImages[0];
      return React__default.createElement(MessageBubble, {
        message: message
      }, React__default.createElement(HeroWithImage, {
        imageUrl: banner === null || banner === void 0 ? void 0 : banner.imageUrl,
        heroLabel: React__default.createElement(React__default.Fragment, null, ' ', category_1 && category_1.department && React__default.createElement(React__default.Fragment, null, React__default.createElement(DepartmentIcon, {
          className: styles.categoryIcon,
          departmentSlug: category_1.department.slug
        }), React__default.createElement("div", {
          className: styles.break
        })), "Get expert advice")
      }), React__default.createElement(CallToAction, {
        onClick: function onClick() {
          return richCardEventEmitter === null || richCardEventEmitter === void 0 ? void 0 : richCardEventEmitter.emitEvent({
            type: ConsumerRichCardEvents.PATH_CREATE_FROM_CATEGORY_WITH_EXPERT,
            expertId: expertId,
            sourceKey: 'guest-chat',
            categorySlug: category_1.slug
          });
        }
      }, "Connect now"));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading message!");
    }
  });
};

GuestChatCreateRequestMessage.handlesMessage = function (message) {
  return !!guestChatCreateRequestRichCard(message);
};

export default GuestChatCreateRequestMessage;
//# sourceMappingURL=index.js.map
